import {FiberNew, Star} from "@mui/icons-material";
import * as React from "react";
import AttendanceVerifiedIcon from "../../../Common/Widgets/AttendanceVerifiedIcon";
import ChangePersonGroupIcon from "../../../Common/Widgets/ChangePersonGroupIcon";
import InviteNotSentToCustomerIcon from "../../../Common/Widgets/InviteNotSentToCustomerIcon";
import PauseCaseIcon from "../../../Common/Widgets/PauseCaseIcon";
import PersonTodoIcon from "../../../Common/Widgets/PersonTodoIcon";
import {Tooltip} from "@mui/material";

const EventOverviewParticipantIndicators = ({member_info, person}) => {
    return (
        <div style={{display: 'flex', justifyContent: 'flex-end'}}>
            <AttendanceVerifiedIcon person={person}/>
            <ChangePersonGroupIcon text="TM" person={person}/>
            <ChangePersonGroupIcon text="MCG" person={person}/>
            <InviteNotSentToCustomerIcon person={person}/>
            <PauseCaseIcon person={person}/>
            <PersonTodoIcon person={person}/>
            {
                (member_info === "Resale") &&
                <Tooltip title="Resale">
                    <Star sx={{fontSize: '20px', color: "#fbd400"}}/>
                </Tooltip>
            }
            {
                (member_info === "New") &&
                <Tooltip title="New">
                    <FiberNew sx={{fontSize: '20px', color: "#000"}}/>
                </Tooltip>
            }
            {
                (member_info === "New | Resale") &&
                <Tooltip title="New Resale">
                    <>
                        <FiberNew sx={{fontSize: '20px', color: "#000"}}/>
                        <Star sx={{fontSize: '20px', color: "#fbd400"}}/>
                    </>
                </Tooltip>
            }
        </div>
    )
}

export default EventOverviewParticipantIndicators;